const PREFIX = '[Undo]';

export const UNDO_RESET = `${PREFIX} RESET`;
export const UNDO = `${PREFIX} UNDO`;
export const REDO = `${PREFIX} REDO`;

export const undoReset = payload => ({
  type: UNDO_RESET,
  payload,
});

export const undo = payload => ({
  type: UNDO,
  payload,
});

export const redo = payload => ({
  type: REDO,
  payload,
});
